export const ERRORS = {
    NETWORK_ERROR: "Please check your internet connection.!"
}